import React, { useState, useEffect } from 'react';
import { getUsers, deleteUserApi } from '../../services/apiService'
import { showApiError } from '../utilities'
import { Form, Button,  Icon, Table, Popconfirm } from 'antd';

const currentUser = window.sessionStorage.getItem("UserName") || "";


function TitleBar(props) {
  //console.log(props)


  function handleClick() {
    props.history.push('/adduser')
  }

  return (
    <div className="panel">
      <Form layout="inline" >
        <Form.Item style={{ float: 'right' }} >
          <Button type="" icon="plus" xhref="/adduser" onClick={handleClick} >Add User</Button>
        </Form.Item>
      </Form>
    </div>)

}

export default function UsersContainer(props) {


  const [userdata, setUserData] = useState([])


  const columns = [
    {
      title: 'Name',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'Delete',
      render: (text, record) => (
        currentUser === record.userName ? '' : <span>
          <Popconfirm placement="topLeft"
            title="Are you sure you want to delete this user"
            onConfirm={() => deleteUser(record.id)}
          > <a  ><Icon type="user-delete" /></a> </Popconfirm>
        </span >
      )
    },
  ];


  useEffect(() => {
    getUsers()
      .then(json => {
      if (typeof json === 'string') {
        throw new Error(json)
      } else {
        //console.log(json)
        setUserData(json)
      }
    })
      .catch(error => {
        showApiError(error)
      })
  }, [])

  function deleteUser(id) {


    deleteUserApi(id)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {

          //window.location.href = "/users"
          setUserData(json)

        }
      })
      .catch(error => {
        showApiError(error)
      })


  }


  return (
    <div className="content">
      <h2>{props.title}</h2>
      <TitleBar {...props}/>
      <Table rowKey="userName" columns={columns} dataSource={ userdata} />

     </div>
  );
}